export const TOKEN_REFRESH_ERROR_CODE = 1001;
